 <div id="cookie-notice-wrapper" [@coockieConsent]="consentValue">
     <p>We use cookies to improve your online experience and the services we offer. To accept cookies continue to browse
         as normal. Read our <a href="https://www.clsq.com/privacy-policy" target="_blank">privacy
             policy</a> for more information.
         <button class="close close" type="button" aria-label="Close" (click)="onAlertClose()"><span
                 aria-hidden="true">&times;</span></button>
     </p>
 </div>
 <!--p((click)="resetCS()") reset-->